module.exports = __webpack_public_path__ + "static/media/Anim_06.a097f9d5.fbx";